import _ from 'lodash';
import { apiSearch } from '../utility';

export const searchMonitoring = (p = {}) => {
	const callback = p.callback || _.noop;
	const onlyLatest = p.onlyLatest;

	return dispatch => {
		apiSearch({
			method : 'monitoring.search',
			base : 'veederInventoryRecord',
			params : { onlyLatest },
			dispatch : dispatch,
			callback : callback,
		});
	};
};
